import { createReducer } from "@reduxjs/toolkit";
import {
  miniGamesRewardsRequest,
  miniGamesRewardsSuccess,
  miniGamesRewardsFailure,
  MiniGamesRewardsData,
  jackpotHistoryRequest,
  jackpotHistorySuccess,
  jackpotHistoryFailure,
  JackpotHistoryData,
} from "./miniGamesRewardsActions";

export type MiniGamesRewardsState = {
  data?: MiniGamesRewardsData;
  loaded: boolean;
  loading: boolean;
  error?: string;
  jackpotHistory?: JackpotHistoryData;
  jackpotHistoryLoading: boolean;
  jackpotHistoryError?: string;
};

const initialState: MiniGamesRewardsState = {
  loading: false,
  loaded: false,
  jackpotHistoryLoading: false,
};

export const miniGamesRewardsReducer = createReducer(initialState, (b) => {
  b.addCase(miniGamesRewardsRequest, (s) => {
    s.loading = true;
    s.error = undefined;
  });

  b.addCase(miniGamesRewardsSuccess, (s, a) => {
    s.loading = false;
    s.loaded = true;
    s.data = a.payload;
  });

  b.addCase(miniGamesRewardsFailure, (s, a) => {
    s.loading = false;
    s.error = a.payload;
  });

  b.addCase(jackpotHistoryRequest, (s) => {
    s.jackpotHistoryLoading = true;
    s.jackpotHistoryError = undefined;
  });

  b.addCase(jackpotHistorySuccess, (s, a) => {
    s.jackpotHistoryLoading = false;
    s.jackpotHistory = a.payload;
  });

  b.addCase(jackpotHistoryFailure, (s, a) => {
    s.jackpotHistoryLoading = false;
    s.jackpotHistoryError = a.payload;
  });
});

// Selectors
export const selectMiniGamesRewards = (state: any) =>
  state.miniGamesRewards.data;

export const selectMiniGamesGoldAmount = (state: any) =>
  state.miniGamesRewards.data?.goldAmount ?? 0;

export const selectMiniGamesRewardsLoading = (state: any) =>
  state.miniGamesRewards.loading;

export const selectMiniGamesRewardsError = (state: any) =>
  state.miniGamesRewards.error;

export const selectJackpotHistory = (state: any) =>
  state.miniGamesRewards.jackpotHistory;

export const selectJackpotHistoryLoading = (state: any) =>
  state.miniGamesRewards.jackpotHistoryLoading;

export const selectJackpotHistoryError = (state: any) =>
  state.miniGamesRewards.jackpotHistoryError;
